$(document).ready(function () {
    $('.numbers').each(function () {
        $(this).animateNumber(
            {
                number: $(this).data('number')
            },
            {
                easing: 'swing',
                duration: 3000
            }
        );
    });
});